import { getInstance } from '../../../lib/axios';
import constants from '../../../constants';

export async function getUserReservation(id) {
  try {
    const url = `${constants.endpoints.USERS_RESERVATION}/${id}`;
    const response = await getInstance().get(url);
    return response.data;
  } catch (error) {
    console.error('Fetch userReservation failed', error.message);
    throw error;
  }
}

export async function createUserReservation(data) {
  try {
    const response = await getInstance().post(constants.endpoints.USERS_RESERVATION, data);
    return response.data;
  } catch (error) {
    console.error('Create userReservation failed', error.message);
    throw error;
  }
}

export async function deleteUserReservation(id) {
  try {
    const url = `${constants.endpoints.USERS_RESERVATION}/${id}`;
    const response = await getInstance().delete(url);
    return response.data;
  } catch (error) {
    console.error('Delete userReservation failed', error.message);
    throw error;
  }
}